import OptimizationProcesses from './OptimizationProcesses'

export default OptimizationProcesses
